/* global MEDIA_FETCH_COUNT: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createPaginationContainer, graphql } from 'react-relay';

import MediaList from './MediaList';

class DualSearchMediaList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
    };
  }

  handleLoadMore = () => {
    if (this.props.relay.isLoading()) {
      return;
    }
    this.setState({ isFetching: true });
    this.props.relay.loadMore(MEDIA_FETCH_COUNT, () => this.setState({ isFetching: false }));
  };

  render() {
    const { isFetching } = this.state;
    const {
      eventHasSearchByFace,
      eventHasSecondFactor,
      media,
      relay,
      offer,
      participantMediaCount,
      impressionMediaCount,
      startnumber,
    } = this.props;

    return (
      <MediaList
        eventHasSearchByFace={eventHasSearchByFace}
        eventHasSecondFactor={eventHasSecondFactor}
        media={media.mediaList}
        hasMore={relay.hasMore()}
        isFetching={isFetching}
        onLoadMore={this.handleLoadMore}
        offer={offer}
        participantMediaCount={participantMediaCount}
        impressionMediaCount={impressionMediaCount}
        listType="dual"
        startnumber={startnumber}
      />
    );
  }
}

DualSearchMediaList.propTypes = {
  eventHasSearchByFace: PropTypes.bool,
  eventHasSecondFactor: PropTypes.bool,
  participantMediaCount: PropTypes.number,
  impressionMediaCount: PropTypes.number,
  startnumber: PropTypes.string,
  media: PropTypes.object,
  offer: PropTypes.object,
  relay: PropTypes.object,
};

export { DualSearchMediaList };

export default createPaginationContainer(
  DualSearchMediaList,
  {
    media: graphql`
      fragment DualSearchMediaList_media on ExtendedMediaConnection {
        mediaList(first: $count, after: $cursor)
          @connection(key: "DualSearchMediaList_mediaList") {
          edges {
            node {
              id
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          ...MediaList_media
        }
      }
    `,
    offer: graphql`
      fragment DualSearchMediaList_offer on Event {
        ...MediaList_offer
      }
    `,
  },
  {
    direction: 'forward',
    // Function that should indicate which connection to paginate over, given the fragment
    // props.
    getConnectionFromProps(props) {
      return props.media && props.media.mediaList;
    },
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, paginationInfo, fragmentVariables) {
      return {
        eventId: props.eventId,
        startnumber: props.startnumber,
        searchStartnumber: props.searchStartnumber,
        count: paginationInfo.count,
        cursor: paginationInfo.cursor,
      };
    },
    query: graphql`
      query DualSearchMediaListPaginationQuery(
        $eventId: ID!
        $startnumber: ID!
        $searchStartnumber: ID!
        $count: Int!
        $cursor: String
        $secondFactor: String
      ) {
        viewer {
          event(id: $eventId) {
            participant(startnumber: $startnumber, secondFactor: $secondFactor) {
              suggestionsByStartnumber(startnumber: $searchStartnumber) {
                mediaInfo {
                  count
                }
                ...DualSearchMediaList_media
              }
            }
          }
        }
      }
    `,
  },
);
